<template>
    <div>
        <app-title text="Clientes" />
        <b-row>
            <b-col cols="12" md="4">
                <b-btn variant="primary" block @click="startSaveClient()"
                    ><i class="fa fa-building-o"></i> Crear nuevo cliente /
                    Prospecto</b-btn
                >
            </b-col>
        </b-row>
        <!-- <button class="btn btn-primary" @click="openprospect()">
            <i class="fa fa-building-o"></i> prospecto
        </button>-->
        <b-card no-body>
            <b-tabs
                card
                content-class="mt-3"
                fill
                @activate-tab="onChangeClientTab"
                v-model="activeTab"
                :value="lastActiveTab"
            >
                <b-tab title="Clientes">
                    <div class="filters mb-2">
                        <app-sub-title text="Filtros" />
                        <div class="card">
                            <div class="card-body">
                                <div class="card-text">
                                    <b-row>
                                        <b-col cols="12" md="2">
                                            <app-form-text-input
                                                placeholder="Nombre"
                                                v-model="filters.name"
                                            />
                                        </b-col>
                                        <b-col cols="12" md="2">
                                            <app-form-text-input
                                                placeholder="Documento"
                                                v-model="filters.document"
                                            />
                                        </b-col>
                                        <b-col cols="12" md="2">
                                            <app-form-select-input
                                                placeholder="Tipo cliente"
                                                :options="clientTypes"
                                                v-model="filters.clientTypeId"
                                            />
                                        </b-col>
                                        <b-col cols="12" md="2">
                                            <app-form-select-input
                                                placeholder="Ciudad"
                                                :options="cities"
                                                v-model="filters.cityId"
                                            />
                                        </b-col>
                                        <b-col cols="12" md="2">
                                            <app-form-select-input
                                                v-model="filters.executiveId"
                                                :options="executives"
                                                placeholder="Ejecutivo"
                                            ></app-form-select-input>
                                        </b-col>
                                        <b-col cols="12" md="2">
                                            <button
                                                @click="searchClients"
                                                class="btn btn-primary btn-block-xs-only mr-2"
                                            >
                                                <i class="fa fa-filter"></i>
                                            </button>
                                            <button
                                                @click="cancelFilter"
                                                class="btn btn-secondary btn-block-xs-only"
                                            >
                                                <i
                                                    class="fa fa-times-circle"
                                                ></i>
                                            </button>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-table-clients
                        :data="data"
                        :on-change-page="onChangePage"
                        :assign-tool="startAssignTools"
                        :configure-client="startConfigureModules"
                        :pick-client="pickClient"
                        :updateClient="startUpdate"
                        :activate-client="startActivateClient"
                        :disable-client="startDisableClient"
                        @sort="onSort"
                    />
                </b-tab>
                <b-tab title="Prospectos">
                    <app-client-prospect-filters
                        @filter="onFilterCommercialInfo"
                        @cancel-filter="onClearCommercialInfo"
                    />
                    <app-client-prospect-list
                        v-if="!!tableData"
                        :table-data="tableData"
                        @edit="updateClientProspect"
                        @remove="startDisableClient"
                        @activate-client="startActivateClient"
                        :on-change-page="onChangePageTableProspect"
                    ></app-client-prospect-list>
                </b-tab>
            </b-tabs>
        </b-card>
        <!-- inicio de pop ups -->

        <app-pop-up
            title="Formulario de cliente"
            id="client-form"
            :onClose="cleanForm"
            size="large"
        >
            <div class="body" slot="body">
                <app-client-form
                    ref="client-form"
                    @edit="onEditProspect"
                    :my-client="selectClient"
                    :onSave="onSave"
                    :onEdit="onEdit"
                ></app-client-form>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('client-form.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Formulario herramientas"
            id="tools-form"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <h5>Cliente: {{ selectClient.name }}</h5>
                <app-assign-tools
                    :onAssigning="onAssigning"
                    :my-client="selectClient"
                ></app-assign-tools>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('assignTools.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Módulos opcionales del cliente"
            id="optional-modules-form"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <h5>Cliente: {{ selectClient.name }}</h5>
                <app-assign-optional-modules
                    :onAssigning="onAssigningOptionalModules"
                    :my-client="selectClient"
                ></app-assign-optional-modules>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('assignOptionalModules.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="activate-client">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea activar el cliente
                    {{ selectClient.name }}?
                </h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="activateClient(selectClient)"
                >
                    Confirmar activación cliente
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="client-disable">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea deshabilitar el cliente
                    {{ selectClient.name }}?
                </h2>
                <h4>Actualmente tiene:</h4>
                <div>
                    {{ this.disableClient.personEntries }} Ingresos de peatones
                </div>
                <div>
                    {{ this.disableClient.vehicleEntries }} Ingresos de
                    vehículos
                </div>
                <div>{{ this.disableClient.notes }} Consignas transitorias</div>
                <div>{{ this.disableClient.mails }} Correspondencias</div>
            </div>

            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteClient(selectClient)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    deshabilitación
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import appClientProspectForm from '../../ClientCommercial/ClientProspectForm/ClientProspectForm'
import clientsRepository from '../../../repositories/clients.repository'
import clientForm from '../ClientForm/ClientForm.vue'
import assignTools from '../ClientForm/AssignTools'
import assignOptionalModules from '../ClientForm/AssignOptionalModules.vue'
import localizationRepository from '../../../repositories/localizationRepository'
import TableClients from './TableClients/TableClients.vue'
import ClientProspectFilters from '../../ClientCommercial/ClientProspectFilters/ClientProspectFilters'
import ClientProspectList from '../../ClientCommercial/ClientProspectList/ClientProspectList'
import { mapGetters } from 'vuex'

export default {
    name: 'clients-list',
    components: {
        appClientForm: clientForm,
        appAssignTools: assignTools,
        appAssignOptionalModules: assignOptionalModules,
        appTableClients: TableClients,
        appClientProspectForm: appClientProspectForm,
        appClientProspectFilters: ClientProspectFilters,
        appClientProspectList: ClientProspectList,
    },
    data() {
        return {
            page: 1,
            selectClient: '',
            data: {},
            filters: {
                name: '',
                document: '',
                clientTypeId: '',
                cityId: '',
            },
            disableClient: {
                notes: '',
                mails: '',
                personEntries: '',
                vehicleEntries: '',
            },
            sort: {
                sortBy: '',
                sortDir: 'asc',
            },
            tableData: null,
            prospectFilters: null,
            activeTab: 0,
        }
    },
    watch: {
        activeTab(newVal) {
            this.$cookies.set('clients.tab', newVal, '1y')
        },
    },
    computed: {
        ...mapGetters(['clientTypes', 'cities', 'executives']),
        lastActiveTab() {
            return parseInt(
                this.$cookies.isKey('clients.tab')
                    ? this.$cookies.get('clients.tab')
                    : this.activeTab
            )
        },
    },
    methods: {
        onChangeClientTab(newTabIndex) {
            this.$cookies.set('clients.tab', newTabIndex, '1m')
        },
        onClearCommercialInfo() {
            this.loadCommercialInfo()
        },
        onEditProspect() {
            this.$bus.$emit('client-form.close')
            this.loadCommercialInfo()
        },
        onFilterCommercialInfo(filters) {
            this.prospectFilters = filters
            this.loadCommercialInfo()
        },
        openPopupProspect() {
            this.loadCommercialInfo()
            this.$bus.$emit('client-commercial-form.open')
        },
        pickClient(client) {
            this.$store.commit('client', client)
            this.$router.push({
                name: 'clientContactsPage',
                params: { clientId: client.id },
            })
        },
        onSave(data) {
            if (data.prospect) {
                this.$bus.$emit('client-form.close')
                this.loadCommercialInfo()
                this.$store.commit('client', data.client)
                this.$router.push({
                    name: 'ClientProspectForm',
                    params: {
                        clientId: data.client.id,
                        name: data.client.name,
                    },
                })
            } else {
                this.$bus.$emit('client-form.close')
                this.loadClients()
            }
        },
        onEdit(data) {
            if (data.prospect) {
                this.$bus.$emit('client-form.close')
                this.loadCommercialInfo()
            }
            this.$bus.$emit('client-form.close')
            this.loadClients()
        },
        onAssigning() {
            this.$bus.$emit('tools-form.close')
        },
        onAssigningOptionalModules() {
            this.$bus.$emit('optional-modules-form.close')
        },
        cleanForm() {
            this.$bus.$emit('client-form.clean')
        },
        async loadClients() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }

            const cr = { ...clientsRepository }
            try {
                this.data = await cr.all(filters, this.page)
            } catch (err) {
                this.handleErrors(err)
            } finally {
            }
        },
        async loadCommercialInfo() {
            try {
                const params = {
                    ...this.prospectFilters,
                    page: this.page,
                    prospect: true,
                }
                const { data } = await repo.get('clients', params)
                this.tableData = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        deleteClient(client) {
            const cr = Object.assign({}, clientsRepository)
            cr.deleteClient(client.id, this.user.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadClients()
                        this.loadCommercialInfo()
                        this.$bus.$emit('client-disable.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el usuario')
                })
        },
        activateClient(client) {
            const cr = Object.assign({}, clientsRepository)
            cr.activateClient(client)
                .then(data => {
                    if (data.status && data.prospect) {
                        toastr.success(data.msg)
                        this.loadCommercialInfo()
                        this.$bus.$emit('activate-client.close')
                    }
                    if (data.status && !data.prospect) {
                        toastr.success(data.msg)
                        this.loadClients()
                        this.$bus.$emit('activate-client.close')
                    }
                    if (!data.status) {
                        toastr.error(data.msg)
                        this.$bus.$emit('activate-client.close')
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo activar el usuario')
                })
        },
        startDisableClient(client) {
            this.selectClient = client

            const cr = Object.assign({}, clientsRepository)
            cr.pendingClientTransactions(client.id)
                .then(data => {
                    this.disableClient.mails = data.mails
                    this.disableClient.notes = data.notes
                    this.disableClient.personEntries = data.personEntries
                    this.disableClient.vehicleEntries = data.vehicleEntries
                })
                .catch(error => {
                    toastr.error(
                        'No se pudo cargar las transacciones pendientes del cliente'
                    )
                })

            this.$bus.$emit('client-disable.open')
        },
        startUpdate(client) {
            this.selectClient = Object.assign({}, client)
            this.$bus.$emit('client-form.open')
        },
        updateClientProspect(client) {
            this.selectClient = Object.assign(
                {},
                { ...client, prospectFlag: true }
            )
            this.$bus.$emit('client-form.open')
        },
        startSaveClient() {
            this.selectClient = ''
            this.$refs['client-form'].changeStateCheckProspect()
            this.$bus.$emit('client-form.open')
        },
        startAssignTools(client) {
            this.selectClient = client
            this.$bus.$emit('tools-form.open')
        },
        startConfigureModules(client) {
            this.selectClient = client
            this.$bus.$emit('optional-modules-form.open')
        },
        startActivateClient(client) {
            this.selectClient = client
            this.$bus.$emit('activate-client.open')
        },
        onChangePage(page) {
            this.page = page
            this.loadClients()
        },
        onChangePageTableProspect(page) {
            this.page = page
            this.loadCommercialInfo()
        },
        searchClients() {
            this.page = 1
            this.loadClients()
        },
        cancelFilter() {
            this.page = 1
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.loadClients()
        },
        loadCities() {
            const lr = { ...localizationRepository }
            lr.getAllCities()
                .then(data => (this.cities = data))
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar las ciudades')
                )
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadClients()
        },
    },
    created() {
        this.loadClients()
        this.loadCommercialInfo()
        this.load('clientTypes')
        this.load('cities')

        if (this.$cookies.isKey('clients.tab')) {
            this.activeTab = parseInt(this.$cookies.get('clients.tab'))
        }
    },
}
</script>
